import { type Dispatch } from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import GroupItem from 'modules/dashboard/components/Groups/GroupPicker/GroupSelector/GroupItem'
import type { CommunitiesDropdown } from 'modules/dashboard/components/Groups/types'

const BlankSlate = () => (
  <Text.Normal>{i18n.t('posts.communities.group_picker.group_selector.blank_slate')}</Text.Normal>
)

interface GroupsListProps {
  options: CommunitiesDropdown[]
  onSelect: Dispatch<CommunitiesDropdown>
  selectedGroup: CommunitiesDropdown | null | undefined
}

const GroupsList = observer(({ options, onSelect, selectedGroup }: GroupsListProps) => {
  if (!options.length) return <BlankSlate />

  return (
    <>
      {options.map((option, index) => (
        <GroupItem
          key={index}
          group={option}
          onSelect={onSelect}
          selected={selectedGroup === option}
        />
      ))}
    </>
  )
})

export default GroupsList
